import React from "react";
import { Restricted, permissions } from "components/auth";
import { AddAction } from "components/buttons";

const ActionButtons = () => (
  <Restricted permissions={[permissions.customer_manage]}>
    <AddAction url={`/customer/new`} />
  </Restricted>
);

export default ActionButtons;
